module.exports = __webpack_public_path__ + "static/media/se.c37f1b98.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/flags/se.svg
// module id = 242
// module chunks = 0